import { useEffect, useRef, useState } from 'react';
import './PlayActionComposer.css';

// Keep keystrokes local so typing never rerenders the Play scene or history.
export default function PlayActionComposer({ savedDraft = '', draftOwnerId = '', inputRef, disabled, inputDisabled = false, isLoading = false, isSubmitting, preserveDraftOnSubmit = false, onSubmit, actions, status, children }) {
  const [draft, setDraft] = useState(savedDraft);
  const previous = useRef({ savedDraft, isSubmitting, draftOwnerId });
  const submitted = useRef(null);

  useEffect(() => {
    if (previous.current.draftOwnerId && previous.current.draftOwnerId !== draftOwnerId) {
      setDraft(savedDraft);
      submitted.current = null;
    }
    else if (isSubmitting && !previous.current.isSubmitting) {
      if (submitted.current !== null && !preserveDraftOnSubmit) setDraft(current => current === submitted.current ? '' : current);
      submitted.current = null;
    }
    else if (!isSubmitting && savedDraft !== previous.current.savedDraft) {
      setDraft(current => current || savedDraft);
    }
    previous.current = { savedDraft, isSubmitting, draftOwnerId };
  }, [savedDraft, isSubmitting, draftOwnerId, preserveDraftOnSubmit]);

  const submit = () => {
    if (!disabled && !isLoading && !isSubmitting && draft.trim()) {
      submitted.current = draft;
      onSubmit(draft);
    }
  };

  return (
    <>
      <div className="editor-field">
        <div className={status === undefined ? undefined : 'play-action-composer-heading'}>
          <label className="field-label" htmlFor="play2-interaction-draft">Action or question</label>
          {status}
        </div>
        <textarea
          ref={inputRef}
          id="play2-interaction-draft"
          className="text-area explore-chat-textarea"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key !== 'Enter' || event.shiftKey || event.nativeEvent?.isComposing) return;
            event.preventDefault();
            submit();
          }}
          aria-label="Action or question"
          disabled={isLoading || inputDisabled}
        />
      </div>
      {children}
      <div className="button-row play-submit-row">
        <button type="button" className="secondary-button" onClick={submit} disabled={disabled || isLoading || isSubmitting || !draft.trim()}>
          {isSubmitting ? 'Thinking...' : 'Submit'}
        </button>
        {actions}
      </div>
    </>
  );
}
